import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import clsx from 'clsx';
import { ClearBetSels } from '../RacingBetline';
import { GlobalContext } from '@/src/contexts/GlobalContext';
import { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { Toast } from '@/src/components/Common/ui-components';
import { useAdobeLaunch } from '@/src/components/Common/utils/adobeLaunch';

function ConfirmClearAllPopup({ onConfirm, onCancel }) {
    const { t } = useTranslation();

    return createPortal(
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.tips}>{t('LB_CONFIRM_CLEAR_ALL_CONTENT')}</div>
                <div className={styles.buttonWrap}>
                    <div className={clsx(styles.normalButton, styles.popupButton)} onClick={onCancel}>
                        {t('LB_CLEAR_ALL_CANCEL')}
                    </div>
                    <div className={clsx(styles.blueButton, styles.popupButton)} onClick={onConfirm}>
                        {t('LB_CLEAR_ALL')}
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById('root')
    );
}

export default function ClearAllHorseSelectionsButton({ isMobileSize, enableBorder, className }) {
    const { t } = useTranslation();
    const { racingPageFunc, clearAllHorseSelectionsButtonDisable } = useContext(GlobalContext);
    const [openConfirmClearAllPopup, setOpenConfirmClearAllPopup] = useState(false);
    const [toastApi, toastContent] = Toast.useToast({ max: 1, showTime: 3000, isRacingClear: true});
    const { sendAdobeEvent } = useAdobeLaunch();

    const handleClearAllClick = () => {
        if (clearAllHorseSelectionsButtonDisable) return;
        setOpenConfirmClearAllPopup(true);
    };

    const handleConfirmClick = () => {
        ClearBetSels();
        racingPageFunc.current.setFOSelectedBet({});
        racingPageFunc.current.resetInvCal();
        racingPageFunc.current.resetAllUpFormula();
        setOpenConfirmClearAllPopup(false);
        toastApi({
            message: t('LB_HORSE_CLEAR_ALL_TIPS')
        });
        if (window.globalConfig.ENABLE_WA_TAGGING_FOR_LOGOUT_MESSAGE_AND_RACING_CLEAR_ALL) {
            sendAdobeEvent({ event: 'interaction', interaction: { eventID: 'eWinRacing_OddsPage_ClickClearSelection' } });
        }
    };

    const handleCancelClick = () => {
        setOpenConfirmClearAllPopup(false);
    };

    return (
        <div
            className={clsx([className, styles.container], {
                [styles.mobileContainerBorder]: isMobileSize && enableBorder
            })}
        >
            {isMobileSize ? (
                <div
                    className={clsx(styles.mobileButton, clearAllHorseSelectionsButtonDisable && styles.mobileDisable)}
                    onClick={handleClearAllClick}
                ></div>
            ) : (
                <div
                    className={clsx(styles.button, clearAllHorseSelectionsButtonDisable && styles.disable)}
                    onClick={handleClearAllClick}
                >
                    {t('LB_CLEAR_ALL')}
                </div>
            )}
            {openConfirmClearAllPopup && (
                <ConfirmClearAllPopup onConfirm={handleConfirmClick} onCancel={handleCancelClick} />
            )}
            {createPortal(toastContent, document.getElementById('scrollView'))}
        </div>
    );
}
